import { isEmploymentTypeMismatch } from './is-employment-type-mismatch';
import { ClaimantColumnDefinition } from './claimant-table.types';
import { ShiftClaimant, ShiftDetailData } from '../claimant-table.types';

export const getClaimantTableData = (
  claimants: ShiftClaimant[],
  shiftDetails: ShiftDetailData,
  hideEmploymentTypeFields = false
): ClaimantColumnDefinition[] => {
  return claimants.map((claimant) => ({
    flexWorkerImage: {
      id: claimant.workerId,
      firstName: claimant.firstName,
      lastName: claimant.lastName,
      imageUrl: claimant.imageUrl,
      relation: claimant.relation,
      isFlexWorker: claimant.isFlexWorker,
      employmentType: hideEmploymentTypeFields ? undefined : claimant.employmentType,
      isReplacement: claimant.isReplacement,
      lenderCompanyName: claimant.lenderCompanyName,
      includeCheckedInIndicator: claimant.includeCheckedInIndicator,
    },
    flexPoolIndicator: claimant.flexPoolIndicator,
    flexWorkerFullName: claimant.flexWorkerFullName,
    employmentTypeMismatch: isEmploymentTypeMismatch(shiftDetails, claimant.employmentType),
    hourlyRate: claimant.hourlyRateCents,
    email: claimant.email,
    phone: claimant.phone,
    noShow: claimant.noShow,
    actions: claimant,
  }));
};
